export function buildAvatarPlaceholder(name: string) {
  return `https://ui-avatars.com/api/?name=${name}&background=000&color=fff`;
}
